/** Characters that can break storage, queries, or imports when used in contact fields.
 * Apostrophes are allowed (e.g. O'dell in a name-derived login or email local-part). */
const UNSAFE_CONTACT_PATTERN = /[,;"<>\\|&\x00-\x1f]/;

export function normalizeContactField(value) {
  return String(value ?? '').trim();
}

/**
 * Email or login identifier for new users (not strict RFC email — usernames allowed).
 */
export function validateLoginIdentifier(value, { required = true } = {}) {
  const normalized = normalizeContactField(value);
  if (!normalized) {
    return required
      ? { ok: false, message: 'Email is required.' }
      : { ok: true, value: null };
  }
  if (UNSAFE_CONTACT_PATTERN.test(normalized)) {
    return {
      ok: false,
      message:
        'Remove commas, quotes, angle brackets, and similar characters.'
    };
  }
  return { ok: true, value: normalized.toLowerCase() };
}

export function validateOptionalPhone(value) {
  const normalized = normalizeContactField(value);
  if (!normalized) {
    return { ok: true, value: null };
  }
  if (UNSAFE_CONTACT_PATTERN.test(normalized)) {
    return {
      ok: false,
      message:
        'Phone cannot include commas, quotes, angle brackets, or similar characters.'
    };
  }
  return { ok: true, value: normalized };
}
